import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateSpecificInfo } from 'repositories/BerthApi/updateSpecificInfo'
import { berthKeys, bookingKeys } from 'repositories/queryKeys'

export function useUpdateSpecificInfo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateSpecificInfo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: berthKeys.managements() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.unassigned() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.details() })
    },
  })
}
